import React, { useEffect, useState } from 'react';
import Select from "react-select";
import "./FactorKolUp.scss";
import NewTabulator from "../../NewTabulator/NewTabulator";

const FactorKolUp = (props) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [filteredOptions, setFilteredOptions] = useState([]);

    const handleChange = (selected) => {
        setSelectedOption(selected);
    };

   

    const columns = [
        { title: "کد کلاس", field: "ClassCode" },
        { title: "عنوان کلاس", field: "Classفitle" },
    ];

    useEffect(() => {
        // Filter options based on search text
        const filtered = props.options.filter((option) =>
          option.label.toLowerCase().includes(searchText.toLowerCase())
        );
        setFilteredOptions(filtered);
      }, [searchText]);

    return (
        <div className='FactorKolUp'>
            <div className="searchBox__">
                <label>جستجو</label>
                <Select
                    value={selectedOption}
                    onChange={handleChange}
                    options={filteredOptions}
                    onInputChange={(inputValue) => setSearchText(inputValue)}
                    isSearchable={true}
                    placeholder='کد کلاس را وارد کنید'
                />
            </div>
            <div className='Table'>
                <NewTabulator
                    columns={columns}
                    // data={sendData.tableData} // Update data prop here
                    style={{ height: "16.7vh", overflowY: "scroll" }}
                    className={"header__color__F1F1F1"}
                />
            </div>
        </div>
    );
};

export default FactorKolUp;
